import { FormField } from "components/form/FormField/FormField";
import { Select } from "components/ui/Select/Select";

import { ANTICOAGULANT_OPTIONS } from "../../utils/anticoagulantOptions";
import style from "./LungsAdditionalInfoForm.module.css";

export const CurrentMedicationSection = ({ form }) => {
  const isAnticoagulantsYes = form.watch("patientOnAnticoagulants") === "true";

  return (
    <div className={style.medications}>
      <FormField name="patientOnAnticoagulants">
        <div className={style.formItemWrapper}>
          <label className={style.addReferralFormLabel}>
            Patient on Anticoagulants
          </label>
          <div style={{ color: "#F72924" }}>*</div>
          <div className={style.winXpSelectWrapper} style={{ width: "100px" }}>
            <Select
              options={ANTICOAGULANT_OPTIONS}
              value={form.watch("patientOnAnticoagulants") || ""}
              onChange={(value) =>
                form.setValue("patientOnAnticoagulants", value)
              }
            />
          </div>
        </div>
      </FormField>

      {isAnticoagulantsYes && (
        <div className={style.formItemWrapper} style={{ marginTop: "16px" }}>
          <div></div>
          <div></div>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  width: "260px",
                }}
              >
                <label
                  className={style.addReferralFormLabel}
                  style={{
                    fontWeight: "400",
                    fontSize: "13px",
                    width: "115px",
                  }}
                >
                  Patient on Aspirin
                </label>
                <div
                  className={style.winXpSelectWrapper}
                  style={{ width: "100px" }}
                >
                  <Select
                    options={ANTICOAGULANT_OPTIONS}
                    value={form.watch("patientOnAspirin") || ""}
                    onChange={(value) =>
                      form.setValue("patientOnAspirin", value)
                    }
                  />
                </div>
              </div>
              <div
                style={{
                  marginTop: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <label
                  className={style.addReferralFormLabel}
                  style={{ fontWeight: "400", fontSize: "13px" }}
                >
                  Details: (Dosage & Frequency)
                </label>
                <input
                  type="text"
                  className={style.winXpInputWrapper}
                  {...form.register("aspirinDetails")}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                marginTop: "4px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  width: "260px",
                }}
              >
                <label
                  className={style.addReferralFormLabel}
                  style={{
                    fontWeight: "400",
                    fontSize: "13px",
                    width: "115px",
                  }}
                >
                  Patient on Plavix
                </label>
                <div
                  className={style.winXpSelectWrapper}
                  style={{ width: "100px" }}
                >
                  <Select
                    options={ANTICOAGULANT_OPTIONS}
                    value={form.watch("patientOnPlavix") || ""}
                    onChange={(value) =>
                      form.setValue("patientOnPlavix", value)
                    }
                  />
                </div>
              </div>
              <div
                style={{
                  marginTop: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <label
                  className={style.addReferralFormLabel}
                  style={{ fontWeight: "400", fontSize: "13px" }}
                >
                  Details: (Dosage & Frequency)
                </label>
                <input
                  type="text"
                  className={style.winXpInputWrapper}
                  {...form.register("plavixDetails")}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                marginTop: "4px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  width: "260px",
                }}
              >
                <label
                  className={style.addReferralFormLabel}
                  style={{
                    fontWeight: "400",
                    fontSize: "13px",
                    width: "115px",
                  }}
                >
                  Patient on Warfarin
                </label>
                <div
                  className={style.winXpSelectWrapper}
                  style={{ width: "100px" }}
                >
                  <Select
                    options={ANTICOAGULANT_OPTIONS}
                    value={form.watch("patientOnWarfarin") || ""}
                    onChange={(value) =>
                      form.setValue("patientOnWarfarin", value)
                    }
                  />
                </div>
              </div>
              <div
                style={{
                  marginTop: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <label
                  className={style.addReferralFormLabel}
                  style={{ fontWeight: "400", fontSize: "13px" }}
                >
                  Details: (Dosage & Frequency)
                </label>
                <input
                  type="text"
                  className={style.winXpInputWrapper}
                  {...form.register("warfarinDetails")}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <FormField name="currentMedication">
        <div className={style.formItemWrapper} style={{ marginTop: "20px" }}>
          <div></div>
          <div></div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              alignItems: "start",
            }}
          >
            <label
              className={style.addReferralFormLabel}
              style={{ fontWeight: "400", fontSize: "13px" }}
            >
              Current Medication:
            </label>
            <textarea
              className={style.winXpInputWrapper}
              style={{ width: "100%", height: "120px", maxWidth: "468px" }}
              {...form.register("currentMedication")}
            />
          </div>
        </div>
      </FormField>
    </div>
  );
};
